
import React, { useState } from "react";
//import Button from "../common/Button";
import styles from "../css/LeadCaptureForm.module.css";

function LeadCaptureForm({ data }: any) {

  const [ formState, setFormState ] = useState<any>({});
  const [ errors, setErrors ] = useState<any>({});
  const [ isSubmitted, setIsSubmitted ] = useState<any>(false);


  const handleInputChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    setFormState( (prevState: any) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors( (prevErrors: any) => ({ ...prevErrors, [name]: null }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    data.formFields.forEach( (field: any) => {
      if (field.required && !formState[field.name]) {
        //newErrors[field.name] = `${field.label} is required`;
      }
      if (field.type === "email" && formState[field.name] && !/\S+@\S+\.\S+/.test(formState[field.name])) {
        //newErrors[field.name] = "Invalid email format";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (validateForm()) {
      // Here you would typically send the form data to your backend
      console.log("Form submitted:", formState);
      setIsSubmitted(true);
    }
  };

  if (isSubmitted) {
    return (
      <div className={styles.thankYouMessage}>
        <h2>{data.thankYouMessage.title}</h2>
        <p>{data.thankYouMessage.message}</p>
      </div>
    );
  }

  return (
    <section className={styles.leadCaptureForm} style={{
      backgroundColor: data.formStyle.backgroundColor,
      color: data.formStyle.textColor,
      borderColor: data.formStyle.borderColor,
      borderRadius: data.formStyle.borderRadius
    }}>
      <h2 className={styles.formTitle}>{data.formTitle}</h2>
      <p className={styles.formDescription}>{data.formDescription}</p>
      <form onSubmit={handleSubmit}>
        {data.formFields.map( (field: any, index: number) => (
          <div key={index} className={styles.formField}>
            <label htmlFor={field.name}>{field.label}</label>

             {field.type === "select" ? (
              <select
                id={field.name}
                name={field.name}
                value={formState[field.name] || ""}
                onChange={handleInputChange}
                required={field.required}
                className={styles.selectField}
              >
                <option value="">{field.placeholder}</option>
                {field.options.map((option: any, optionIndex: number) => (
                  <option key={optionIndex} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            ) : field.type === "textarea" ? (
              <textarea
                id={field.name}
                name={field.name}
                value={formState[field.name] || ""}
                onChange={handleInputChange}
                placeholder={field.placeholder}
                required={field.required}
                className={styles.textareaField}
              />
            ) : (
              <input
                type={field.type}
                id={field.name}
                name={field.name}
                value={formState[field.name] || ""}
                onChange={handleInputChange}
                placeholder={field.placeholder}
                required={field.required}
                className={styles.inputField}
              />
            )}
            {errors[field.name] && <p className={styles.errorMessage}>{errors[field.name]}</p>}
          </div>
        ))}

        {data.privacyPolicyText && (
          <p className={styles.privacyPolicy}>{data.privacyPolicyText}</p>
        )}
        {data.termsAndConditionsText && (
          <p className={styles.termsAndConditions}>{data.termsAndConditionsText}</p>
        )}
        {data.gdprConsentText && (
          <div className={styles.gdprConsent}>
            <input
              type="checkbox"
              id="gdprConsent"
              name="gdprConsent"
              required
              onChange={handleInputChange}
            />
            <label htmlFor="gdprConsent">{data.gdprConsentText}</label>
          </div>
        )}
        {/*<Button {...data.submitButton} type="submit" />*/}
      </form>
    </section>
  );
}


export default LeadCaptureForm;